var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"de15ce17c2e007ff7ec06e55cd1b487f2ffa7f2c"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["payex-web@flywire"]={id:"de15ce17c2e007ff7ec06e55cd1b487f2ffa7f2c"};
      